/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Harden_Output6Inputs */

const en_svc_messaging_bots_harden_output6 = /** @type {(inputs: Svc_Messaging_Bots_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Production runbook`)
};

const ar_svc_messaging_bots_harden_output6 = /** @type {(inputs: Svc_Messaging_Bots_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دليل التشغيل الإنتاجي`)
};

const bn_svc_messaging_bots_harden_output6 = /** @type {(inputs: Svc_Messaging_Bots_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রোডাকশন রানবুক`)
};

const de_svc_messaging_bots_harden_output6 = /** @type {(inputs: Svc_Messaging_Bots_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produktions-Runbook`)
};

const es_svc_messaging_bots_harden_output6 = /** @type {(inputs: Svc_Messaging_Bots_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runbook de producción`)
};

const fr_svc_messaging_bots_harden_output6 = /** @type {(inputs: Svc_Messaging_Bots_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runbook de production`)
};

const pt_svc_messaging_bots_harden_output6 = /** @type {(inputs: Svc_Messaging_Bots_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livro de produção`)
};

const zh_svc_messaging_bots_harden_output6 = /** @type {(inputs: Svc_Messaging_Bots_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生产操作手册`)
};

const tr_svc_messaging_bots_harden_output6 = /** @type {(inputs: Svc_Messaging_Bots_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üretim runbook'u`)
};

const ru_svc_messaging_bots_harden_output6 = /** @type {(inputs: Svc_Messaging_Bots_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рабочая книга`)
};

const pl_svc_messaging_bots_harden_output6 = /** @type {(inputs: Svc_Messaging_Bots_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkcyjny element Runbook`)
};

/**
* | output |
* | --- |
* | "Production runbook" |
*
* @param {Svc_Messaging_Bots_Harden_Output6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_harden_output6 = /** @type {((inputs?: Svc_Messaging_Bots_Harden_Output6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Harden_Output6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_harden_output6(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_harden_output6(inputs)
	if (locale === "de") return de_svc_messaging_bots_harden_output6(inputs)
	if (locale === "es") return es_svc_messaging_bots_harden_output6(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_harden_output6(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_harden_output6(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_harden_output6(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_harden_output6(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_harden_output6(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_harden_output6(inputs)
	return en_svc_messaging_bots_harden_output6(inputs)
});
export { svc_messaging_bots_harden_output6 as "svc_messaging-bots_HARDEN_output" }